import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { RadioGroup, Radio, Grid, FormControlLabel } from '@material-ui/core';
import CardBankItem from "../../components/CardBankItem";

const useStyles = makeStyles({
  gridCard: {
    position: 'relative',
    borderRight: '1px solid rgba(0, 0, 0, 0.10)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
    boxShadow: 'initial',
    transition: 'all 0.5s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0px 8px 14px -5px rgba(0,0,0,0.75)',
    }
  },
  gridCardDam: {
    position: 'relative',
    borderRight: '1px solid rgba(0, 0, 0, 0.10)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
    boxShadow: 'initial',
    transition: 'all 0.5s',
    cursor: 'default !important'
  },
  radioGroup: {
    flexDirection: 'initial',
    width: '100%',
  },
  radioLabel: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    right: -15,
  },
  radioItem: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
  },

});

const GreenRadio = withStyles({
  root: {
    color: 'rgba(24, 116, 185, 0.27)',
    '&:hover':{
      color: '#1874B9',
    },
    '&$checked': {
      color: '#1874B9',
    },
  },
  checked: {},
})(props => <Radio color="default" {...props} />);

function CardBankGroup(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState("0");

  function handleChange(event){
    setValue(event.target.value)
    props.handleBankSelected(event.target.value)
  }

  return (
    <div>
      <RadioGroup
        aria-label="Bank"
        className={classes.radioGroup}
        value={value}
        onChange={handleChange}
      >
      {props.banks.length > 0 &&
        props.banks.map(item => {
          return(
            <Grid key={item.CodigoBanco} item xs={6} sm={6} md={3} className={(props.staticLogoDam ? classes.gridCardDam : classes.gridCard)} style={{flexBasis:'17%'}} elevation={0}>
              {props.typeCard === 'onlinePayment' && (
                <FormControlLabel
                  value={item.CodigoBanco.toString()}
                  className={classes.radioLabel}
                  control={
                    <GreenRadio className={classes.radioItem}/>
                  }
                />
              )}
                <CardBankItem image={"data:image/png;base64," + item.ImagemLogoBanco} staticLogoDam={props.staticLogoDam} />
            </Grid>
          )
        })
      }
      </RadioGroup>
    </div>
  );
}

export default CardBankGroup
